export default {
    methods: {
        afterEnter(element) {
            element.style.height = 'auto';
        },
        enter(element) {
            const { width } = getComputedStyle(element);

            element.style.width = width;
            element.style.position = 'absolute';
            element.style.visibility = 'hidden';
            element.style.height = 'auto';

            const { height } = getComputedStyle(element);

            element.style.width = null;
            element.style.position = 'static'; /* For IE fix*/
            element.style.visibility = 'visible';
            element.style.height = 0;

            requestAnimationFrame(() => {
                element.style.height = height;
            });
        },
        leave(element) {
            const { height } = getComputedStyle(element);

            element.style.height = height;

            requestAnimationFrame(() => {
                element.style.height = 0;
            });
        },
    },
};
